import React, { useState } from "react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed w-full top-0 z-50 bg-gray-800 shadow-md">
      <div className="max-w-7xl mx-auto px-6 py-3 flex justify-between items-center">
        <a href="#hero">
          <img
            src="/eforum_logo.png"
            alt="Opslytic Logo"
            style={{ height: '60px' }}
          />
        </a>
        <button
          className="text-gray-300 md:hidden focus:outline-none"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <svg
            className="w-8 h-8"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            {menuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>

        <nav className="hidden md:flex space-x-8 text-lg">
          <a href="#hero" className="text-gray-300 hover:text-white transition">Home</a>
          <a href="#services" className="text-gray-300 hover:text-white transition">Services</a>
          <a href="#contact" className="text-gray-300 hover:text-white transition">Contact</a>
        </nav>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-gray-800 text-center px-4 pb-4">
          <a href="#hero" className="block py-2 text-gray-300 hover:text-white transition">Home</a>
          <a href="#services" className="block py-2 text-gray-300 hover:text-white transition">Services</a>
          <a href="#contact" className="block py-2 text-gray-300 hover:text-white transition">Contact</a>
        </div>
      )}
    </header>
  );
}
